// Généré — ne pas éditer à la main.
// Matrice réelle d'un QR version 3, correction M, encodant « https://app.free-qrcode.app ».
// Régénération (depuis apps/api) :
//   node -e "const QR=require('qrcode');const q=QR.create('https://app.free-qrcode.app',{errorCorrectionLevel:'M'});const r=[];for(let y=0;y<q.modules.size;y++){let s='';for(let x=0;x<q.modules.size;x++)s+=q.modules.get(x,y)?'1':'0';r.push(s);}console.log(JSON.stringify(r,null,2));"
// Généré le 2026-10-06 — 29×29, 429 modules sombres.
export const QR_MATRIX_ROWS = [
  '11111110100010110111101111111',
  '10000010010011011000001000001',
  '10111010110101000100101011101',
  '10111010100100110010101011101',
  '10111010111100011100101011101',
  '10000010101101001101001000001',
  '11111110101010101010101111111',
  '00000000010011000110000000000',
  '00111111000111101010010111101',
  '10111001011010101001010101101',
  '10111010110110001000110101111',
  '01001100000111000000010011100',
  '11010111010111110001111000011',
  '00001101000001110000011101001',
  '00101110100101101001011010011',
  '10001101110001111100011111000',
  '10110110010110100101101001011',
  '00011100100010001000011100000',
  '10011011011000110011110101101',
  '10001001110101010100011101100',
  '10101111011001001110111110110',
  '00000000010100110100100010100',
  '11111110110101010100101010100',
  '10000010110100001100100011110',
  '10111010110001110111111110111',
  '10111010100110101000011001110',
  '10111010100010101110111011101',
  '10000010000100010001110010110',
  '11111110010001000100110110000',
];
